/**
 * LoadingPage Component
 * Loading page shown while documents are being processed
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingPageProps {
  batchNumber: string;
  productName?: string;
  progress: number; // 0-100
  status: string;
  error?: string | null;      // Error message if processing failed
  onRetry?: () => void;       // Callback to retry/return to start page
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  batchNumber,
  productName = 'No Data',
  progress,
  status,
  error,
  onRetry
}) => {
  return (
    <div className="min-h-[600px] flex items-center justify-center">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto mb-8">
            {!error ? (
              <Loader2 size={64} className="mx-auto text-green-600 animate-spin" />
            ) : (
              <div className="mx-auto w-24 h-24 rounded-full bg-red-100 flex items-center justify-center">
                <span className="text-5xl text-red-600">✕</span>
              </div>
            )}
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {error ? 'Processing Failed' : 'Processing Documents'}
          </h2>
          <p className="text-gray-600 mb-4">
            Batch <span className="font-semibold text-green-600">{batchNumber}</span>
          </p>
          {!error && (
            <p className="text-lg font-semibold text-green-600 mb-1">{progress}%</p>
          )}
          <p className={`text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
            {status}
          </p>

          {error && onRetry && (
            <button
              onClick={onRetry}
              className="mt-6 px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded font-medium"
            >
              Return to Start Page
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
